export const API_GET_STREETS_POSTALCODE = 'API_GET_STREETS_POSTALCODE'
export const API_GET_STREETS_POSTALCODE_SUCCESS = 'API_GET_STREETS_POSTALCODE_SUCCESS'
export const API_GET_STREETS_POSTALCODE_FAIL = 'API_GET_STREETS_POSTALCODE_FAIL'